import React, { ChangeEvent, useContext, useEffect } from 'react';
import { Box } from '@material-ui/core';

import OpcoesBuscaPopoverAllFilter from 'components/util/opcoesBuscaPopoverAllFilters/.mixins';

import { FiltersContext } from 'pages/orderHistory/hooks/FiltersContext';
import { useFiltersTags } from 'pages/orderHistory/hooks/useFilters/useFiltersTags';
import { useDateFilters } from 'pages/orderHistory/hooks/useFilters/useDateFilters';
import { useBranchFilters } from 'pages/orderHistory/hooks/useFilters/useBranchFilters';
import { useFilterValidation } from 'pages/orderHistory/hooks/useFilters/useFilterValidation';
import { useGroupsAndFamiliesFilters } from 'pages/orderHistory/hooks/useFilters/useGroupsAndFamiliesFilters';
import { AuthContext } from 'contexts/AuthContext';
import { useSnackbar } from '../../../../hooks/snackbar';
interface ISearchOptionsProps {
  searchField: string;
  handleChangeSearchField: (e: ChangeEvent<HTMLInputElement>) => void;
  clearSearchField: () => void;
}

export const SearchOptions = ({ searchField, handleChangeSearchField, clearSearchField }: ISearchOptionsProps) => {
  const { toggleSnackbar, Snackbar } = useSnackbar();

  const {
    user: { isVisaoTok }
  } = useContext(AuthContext);

  const { setFilters, clearPagination, filterTags, currentSupplierId } = useContext(FiltersContext);

  const { SnackbarFilterValidation, isFilterTypeValid } = useFilterValidation();

  const { filterCheckboxes, handleClickFilterCheckbox, handleClearFilterTag, getFilterTags, clearFilterTags } =
    useFiltersTags({ isFilterTypeValid, searchField, clearSearchField });

  const {
    initialDate,
    endDate,
    dateType,
    handleChangeDateType,
    handleChangeEndDate,
    handleChangeInitialDate,
    resetDateFilters
  } = useDateFilters();

  const {
    groups,
    groupsError,
    selectedGroup,
    handleChangeGroups,
    families,
    selectedFamily,
    handleChangeFamilies,
    areFamilyFiltersActive,
    disableFamilyFilters,
    clearGroupAndFamilyFilters,
    getGrupoFamiliaFilters
  } = useGroupsAndFamiliesFilters();

  const { branchOptions, selectedBranch, handleChangeSelectedBranch, clearBranchFilters } = useBranchFilters();

  const areFilterTagsApplied = () => !!Object.keys(getFilterTags()).length;

  const applyFilters = () => {
    const filtersTags = areFilterTagsApplied() && getFilterTags();
    const groupsAndFamiliesFilters = getGrupoFamiliaFilters();

    clearPagination();
    setFilters((prev) => ({ ...prev, ...filtersTags, ...groupsAndFamiliesFilters }));
  };

  const clearQueryFilters = () => {
    const keepFilters = [
      'personId',
      'statusSciaIs',
      'initialRow',
      'nextRows',
      'initialIssueDate',
      'finalIssueDate',
      'initialScheduleDate',
      'finalScheduleDate'
    ];

    setFilters((prev) =>
      Object.fromEntries(
        Object.entries(prev).map(([key, value]) => {
          if (keepFilters.includes(key)) {
            return [key, value];
          }
          return [key, undefined];
        })
      )
    );
  };

  const handleClearFilters = () => {
    resetDateFilters();
    clearFilterTags();
    clearBranchFilters();
    clearSearchField();
    clearGroupAndFamilyFilters();
    clearPagination();
    clearQueryFilters();
  };

  useEffect(() => {
    if (isVisaoTok && currentSupplierId !== 0) {
      handleClearFilters();
    }
  }, [currentSupplierId]);

  useEffect(() => {
    if (groupsError.error) {
      toggleSnackbar({ message: groupsError.message, type: 'warning', duration: 8000 });
    }
  }, [groupsError]);

  return (
    <Box width="175px">
      <Snackbar />
      <OpcoesBuscaPopoverAllFilter
        searchField={searchField}
        dtInitial={initialDate}
        dtEnd={endDate}
        escolhaData={dateType}
        escolhaFilial={selectedBranch}
        isColunasMultiple
        //
        colunas={filterCheckboxes}
        colunasFilterTags={filterTags}
        opcoesFilial={branchOptions}
        //
        handlerAplicarFilters={applyFilters}
        handlerClickCheckbox={handleClickFilterCheckbox}
        handlerCleanFilters={handleClearFilters}
        handleChangeSearchFieldPedido={handleChangeSearchField}
        handlerClearFilterTag={handleClearFilterTag}
        handlerChangeEscolhaFilial={handleChangeSelectedBranch}
        handlerChangeDateInitial={handleChangeInitialDate}
        handlerChangeDateEnd={handleChangeEndDate}
        handlerChangeRadioEscolhaData={handleChangeDateType}
        //
        opcoesGrupos={groups}
        escolhaGrupo={selectedGroup}
        handleChangeGrupos={handleChangeGroups}
        opcoesFamilias={families}
        escolhaFamilia={selectedFamily}
        handleChangeFamilias={handleChangeFamilies}
        isSelectFamiliasDisabled={!areFamilyFiltersActive}
        disableSelectFamilias={disableFamilyFilters}
      />

      <SnackbarFilterValidation />
    </Box>
  );
};
